import { render, staticRenderFns } from "./GongTongArticle.vue?vue&type=template&id=73278406&scoped=true&"
import script from "./GongTongArticle.vue?vue&type=script&lang=js&"
export * from "./GongTongArticle.vue?vue&type=script&lang=js&"
import style0 from "./GongTongArticle.vue?vue&type=style&index=0&id=73278406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73278406",
  null
  
)

export default component.exports